import Auth from '@/common/auth/index'

export default {
  getKey () {
    const decodedToken = Auth.GetDecodedToken()
    const uid = decodedToken.uid

    return `preferences.${uid}`
  },
  canAccess () {
    return Auth.IsLoggedIn()
  },
  /**
   * @returns {UserPreferences|null}
   */
  select () {
    if (this.canAccess()) {
      const key = this.getKey()
      const preferences = localStorage.getItem(key)

      return preferences !== null ? JSON.parse(preferences) : {}
    }

    return null
  },
  /**
   * @param {UserPreferences} preferences
   */
  commit (preferences) {
    const key = this.getKey()
    return localStorage.setItem(key, JSON.stringify(preferences))
  },
  /**
   * @param {string} key
   * @param {*} value
   * @returns {boolean}
   */
  Set (key, value) {
    if (this.canAccess()) {
      const preferences = this.select()
      preferences[key] = value
      this.commit(preferences)

      return true
    }

    return false
  },
  /**
   * @param {string} key
   * @returns {any|null}
   */
  Get (key) {
    if (this.canAccess()) {
      const preferences = this.select()
      return preferences[key]
    }

    return null
  },
  /**
   * @param {string} key
   * @returns {boolean}
   */
  Unset (key) {
    if (this.canAccess()) {
      const preferences = this.select()
      delete preferences[key]
      this.commit(preferences)

      return false
    }

    return true
  }
}



// WEBPACK FOOTER //
// ./src/common/user/preferences.js